import {
  titleUI,
  currentOrPastDateSchema,
  currentOrPastDateRangeUI,
  // textUI,
  selectUI,
} from 'platform/forms-system/src/js/web-component-patterns';

import { servicesOptions } from '../../../../utils/labels';
import content from '../../../../utils/content.json';

/** @type {PageSchema} */
export default {
  title: 'Service period',
  path: 'veteran/service-period',
  uiSchema: {
    ...titleUI(
      content['military-service-period-title'],
      'We use this information to find the Veteran’s service records. You can use approximate dates.',
    ),
    serviceBranch: {
      ...selectUI({
        title: 'Select branch of service',
        options: servicesOptions,
      }),
      'ui:errorMessages': {
        required: 'Select a branch',
      },
    },
    activeServiceDateRange: currentOrPastDateRangeUI(
      {
        title: content['military-service-active-range-start'],
      },
      {
        title: content['military-service-active-range-end'],
      },
      content['military-service-active-range-error'],
    ),
  },
  schema: {
    type: 'object',
    required: ['serviceBranch', 'activeServiceDateRange'],
    properties: {
      serviceBranch: {
        type: 'string',
        enum: servicesOptions.map(option => option.value),
        enumNames: servicesOptions.map(option => option.label),
      },
      activeServiceDateRange: {
        type: 'object',
        required: ['from', 'to'],
        properties: {
          from: currentOrPastDateSchema,
          to: currentOrPastDateSchema,
        },
      },
    },
  },
};
